
import { tryExcel } from "./example/excel";

tryExcel();